'use strict';

/**
 *
 * @name: apiBookmarkService
 *
 */

function ApiBookmarkService($http, $rootScope) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  function createBookmark(postId) {

    var data = {
      UserId: $rootScope.profile.id,
      PostId: postId
    };

    var target = $rootScope.apiUrlNew + '/bookmark';

    return $http.post(target, data);
  }

  function deleteBookmark(postId) {

    var target = $rootScope.apiUrlNew + '/bookmark?' + '&UserId=' + ($rootScope.profile.id) + (postId ? '&PostId=' + postId : '');

    return $http.delete(target);
  }

  function getBookmarks(order) {

    var target = $rootScope.apiUrlNew + '/bookmark?' + '&UserId=' + ($rootScope.profile.id) + (order ? '&order=' + order : '&order=createdAt asc');

    return $http.get(target);
  }

  function importBookmarks(importArray) {

    var data = {
      items: []
    };

    importArray.forEach(function(item, index) {

      if ((item || item === 0) && (index || index === 0)) {

        var bookmark = {
          UserId: $rootScope.profile.id,
          PostId: index
        };

        data.items.push(bookmark);
      }
    });

    var target = $rootScope.apiUrlNew + '/bookmark/import';

    return $http.post(target, data);
  }

  /**
   *
   * @PRIVATE
   *
   */

  return {
    createBookmark: createBookmark,
    deleteBookmark: deleteBookmark,
    getBookmarks: getBookmarks,
    importBookmarks: importBookmarks
  };
}

export default ApiBookmarkService;



// WEBPACK FOOTER //
// ./app/components/_api/bookmark.service.js